import './HoldersTable.css'

const addressToOwner = {
    erd1qqqqqqqqqqqqqpgq3z36wc2tnjlmatu5cylxrjcd39j02wztyl5samaxqg: 'Staking',
    erd1qqqqqqqqqqqqqpgqd9rvv2n378e27jcts8vfwynpx0gfl5ufz6hqhfy0u0: 'Deadrare',
    erd1qqqqqqqqqqqqqpgq6wegs2xkypfpync8mn2sa5cmpqjlvrhwz5nqgepyg8:
        'Trust Market',
}

export default function HoldersTable({ data, totalCount }) {
    return (
        <div className="table-responsive">
            <table className="holders-table table">
                <thead>
                    <tr>
                        <th scope="col" className="count-th">
                            Count
                        </th>
                        <th scope="col">Owner</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(({ owner, count }, index) => {
                        const isEven = index % 2
                        return (
                            <tr
                                key={owner}
                                className={isEven ? 'bg-light' : 'bg-white'}
                            >
                                <td className="count-col">
                                    <div
                                        className={
                                            isEven ? 'bg-light' : 'bg-white'
                                        }
                                    >
                                        {count}
                                    </div>
                                </td>
                                <th scope="row">
                                    <a
                                        href={`https://eglry.com/a/${owner}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {addressToOwner[owner] ?? owner} (
                                        {((count / totalCount) * 100).toFixed(
                                            1
                                        )}{' '}
                                        %)
                                    </a>
                                </th>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
